import { ExtrudeSurfaceT } from "pytha";

/**
 * 屋面板
 */
export class RoofSlapT extends ExtrudeSurfaceT {
    type = "RoofSlapT";

}